import React from "react";
import c from "./Header.module.scss";
import Clock from "../../Clock/Clock";
import IconLive from "../../icons/IconLive";
import IconParking from "../../icons/IconParking";


interface IProps {
  children?: React.ReactNode;
}

const Header: React.FC<IProps> = (props) => {
  return (
    <div className={c.header}>
      <div className={c.headerTop}>
        <div className={c.headerClock}>
          <Clock/>
          <IconLive/>
        </div>
        <div className={c.headerRefreshText}>Оновлення кожні 30 с</div>
      </div>

      <div className={c.headerBottom}>
        <div className={c.headerBottomName}>
          <IconParking/> Parking
        </div>
        <div className={c.headerBottomFree}>
          ВІЛЬНО
        </div>
      </div>

    </div>
  );
};

export default Header;